// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nMzJZ","top":"styles_top__bMSns"};